import { render, staticRenderFns } from "./WorkFlowCategoryFilter.vue?vue&type=template&id=641cafc0&"
import script from "./WorkFlowCategoryFilter.vue?vue&type=script&lang=js&"
export * from "./WorkFlowCategoryFilter.vue?vue&type=script&lang=js&"
import style0 from "./WorkFlowCategoryFilter.vue?vue&type=style&index=0&id=641cafc0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports